export function finite(value) {
  return value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));
}

export function number(value, digits = 2) {
  return finite(value) ? new Intl.NumberFormat('en', { minimumFractionDigits: digits,
    maximumFractionDigits: digits }).format(Number(value)) : '—';
}

export function percent(value, signed = false) {
  return finite(value) ? `${signed && Number(value) > 0 ? '+' : ''}${number(value)}%` : '—';
}

export function money(value, currency) {
  if (!finite(value)) return '—';
  if (!currency) return number(value);
  try { return new Intl.NumberFormat('en', { style: 'currency', currency,
    currencyDisplay: 'code', maximumFractionDigits: 2 }).format(Number(value)); }
  catch { return number(value); }
}

export function date(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  return Number.isNaN(parsed.valueOf()) ? '—' : parsed.toISOString().slice(0, 10);
}
